import React from 'react'
import '../pages/writing.css'
import ProjectCard from '../components/Projectcard'
import data from '../data/project.json'
import { ReactDOM, useState} from 'react'

function ProjectContainer() {
  const [items, setItems] = useState(data);

  return (
    <>
      <div className='cards'>
        {items.reverse().map((item,index) => (
          <ProjectCard
            key={index}
            title={item.title}
            tech={item.tech}
            desc={item.desc}
            link={item.link}
          />
        ))}
      </div>
    </>
  )
}

export default ProjectContainer